import { useEffect } from "react";
import { X, Trash2, ShoppingCart } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "@/context/CartContext";
import { QtyStepper } from "@/components/ProductCard";
import { inr } from "@/lib/api";

export default function CartDrawer() {
  const { open, setOpen, items, setQty, remove, subtotal, count } = useCart();
  const nav = useNavigate();
  useEffect(() => { document.body.style.overflow = open ? "hidden" : ""; }, [open]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50" data-testid="cart-drawer">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setOpen(false)} />
      <div className="absolute inset-y-0 right-0 w-full sm:w-[420px] bg-white shadow-2xl flex flex-col animate-fade-up">
        <div className="flex items-center justify-between px-5 py-4 border-b border-slate-100">
          <h2 className="text-lg font-bold flex items-center gap-2"><ShoppingCart size={18} className="text-emerald-600" /> Your Cart <span className="text-sm text-slate-400">({count})</span></h2>
          <button data-testid="close-cart" onClick={() => setOpen(false)} className="p-1.5 hover:bg-slate-100 rounded-lg"><X size={20} /></button>
        </div>
        {items.length === 0 ? (
          <div className="flex-1 flex flex-col items-center justify-center text-slate-400 gap-3">
            <ShoppingCart size={48} className="opacity-30" />
            <p className="font-medium">Your cart is empty</p>
            <button onClick={() => { setOpen(false); nav("/"); }} className="text-emerald-600 font-semibold text-sm">Start shopping</button>
          </div>
        ) : (
          <>
            <div className="flex-1 overflow-y-auto px-4 py-3 space-y-3">
              {items.map((it) => (
                <div key={it.product_id} data-testid={`cart-item-${it.product_id}`} className="flex gap-3 items-center bg-slate-50 rounded-xl p-2.5">
                  <img src={it.image} alt={it.name} className="w-14 h-14 rounded-lg object-cover" />
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-semibold line-clamp-1">{it.name}</p>
                    <p className="text-xs text-slate-400">{it.unit}</p>
                    <p className="text-sm font-bold mt-0.5">{inr(it.price * it.quantity)}</p>
                  </div>
                  <div className="w-24"><QtyStepper testid={`cart-stepper-${it.product_id}`} qty={it.quantity} onInc={() => setQty(it.product_id, it.quantity + 1)} onDec={() => setQty(it.product_id, it.quantity - 1)} /></div>
                  <button data-testid={`cart-remove-${it.product_id}`} onClick={() => remove(it.product_id)} className="p-1.5 text-slate-400 hover:text-red-500"><Trash2 size={16} /></button>
                </div>
              ))}
            </div>
            <div className="border-t border-slate-100 p-4 space-y-3">
              <div className="flex justify-between font-bold text-lg"><span>Subtotal</span><span>{inr(subtotal)}</span></div>
              <button data-testid="go-to-checkout" onClick={() => { setOpen(false); nav("/checkout"); }}
                className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold transition-colors">
                Proceed to Checkout
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
